import React from 'react';
import {GridCounterProps} from "../../ImageGrid/props";

export const GridCounter = ({ current, total }: GridCounterProps) => {
  if (!total) {
    return null;
  }
  return (
    <div className="image-grid__counter">
      {current} / {total}
    </div>
  );
};